import { render, staticRenderFns } from "./Swift2021.vue?vue&type=template&id=1a90eeae&"
import script from "./Swift2021.vue?vue&type=script&lang=ts&"
export * from "./Swift2021.vue?vue&type=script&lang=ts&"
import style0 from "./Swift2021.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports